var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.childData,
            rules: _vm.rules,
            "label-position": "right",
            "label-width": "80px"
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "单位名称", prop: "companyName" } },
            [
              _c("el-input", {
                staticClass: "form-item-width",
                model: {
                  value: _vm.childData.companyName,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "companyName", $$v)
                  },
                  expression: "childData.companyName"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "单位地址" } },
            [
              _c("el-input", {
                staticClass: "form-item-width",
                attrs: { maxlength: "100" },
                model: {
                  value: _vm.childData.companyAddr,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "companyAddr", $$v)
                  },
                  expression: "childData.companyAddr"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "法人代表" } },
            [
              _c("el-input", {
                staticClass: "form-item-width",
                attrs: { maxlength: "100" },
                model: {
                  value: _vm.childData.companyLegal,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "companyLegal", $$v)
                  },
                  expression: "childData.companyLegal"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "单位电话" } },
            [
              _c("el-input", {
                staticClass: "form-item-width",
                attrs: { maxlength: "20" },
                model: {
                  value: _vm.childData.companyPhone,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "companyPhone", $$v)
                  },
                  expression: "childData.companyPhone"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "备注" } },
            [
              _c("el-input", {
                staticClass: "form-item-width",
                attrs: {
                  type: "textarea",
                  autosize: { minRows: 6, maxRows: 6 }
                },
                on: { input: _vm.handleRemarkInput },
                model: {
                  value: _vm.childData.remark,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "remark", $$v)
                  },
                  expression: "childData.remark"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handCancle } }, [
            _vm._v(_vm._s(_vm.$t("button.cancel")))
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handCreate } },
            [_vm._v(_vm._s(_vm.$t("button.confirm")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }